/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CutInputs */

const en_cut = /** @type {(inputs: CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cut`)
};

const fr_cut = /** @type {(inputs: CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couper`)
};

const de_cut = /** @type {(inputs: CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schneiden`)
};

const it_cut = /** @type {(inputs: CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taglio`)
};

const ru_cut = /** @type {(inputs: CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Резать`)
};

const es_cut = /** @type {(inputs: CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cortar`)
};

const zh_cn2_cut = /** @type {(inputs: CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切`)
};

const ja_cut = /** @type {(inputs: CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カット`)
};

const hi_cut = /** @type {(inputs: CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`काटना`)
};

const pt_pt2_cut = /** @type {(inputs: CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corte`)
};

/**
* | output |
* | --- |
* | "Cut" |
*
* @param {CutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cut = /** @type {((inputs?: CutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cut(inputs)
	if (locale === "de") return de_cut(inputs)
	if (locale === "it") return it_cut(inputs)
	if (locale === "ru") return ru_cut(inputs)
	if (locale === "es") return es_cut(inputs)
	if (locale === "zh-CN") return zh_cn2_cut(inputs)
	if (locale === "ja") return ja_cut(inputs)
	if (locale === "hi") return hi_cut(inputs)
	if (locale === "pt-PT") return pt_pt2_cut(inputs)
	return en_cut(inputs)
});